export const EMAIL_REGEX =
  /^[a-zA-Z0-9]([a-zA-Z0-9_.]+)@(([[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.)|(([a-zA-Z0-9]+.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(]?)$/i;

export const validateEmail = (value: string) =>
  new RegExp(EMAIL_REGEX).test(value);
